<script setup>

import TextInput from "@/components/common/input/TextInput.vue";
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown";

import {useStore} from "vuex";
import {useGetValidatedFields} from "@/composables/common/useGetValidatedFields";
import {computed, inject} from "vue";

const validationViewModel = inject("validationViewModel");

const store = useStore();

const emit = defineEmits(['useContact']);

const requiredFieldsList = computed(() => {

  return props.requiredFields
})

const props = defineProps({

  modelValue: {},
  requiredFields: {type: Array, default: []},
  validationModel: ''
})


function useContact() {

  emit("useContact");
}

</script>

<template>
  <div class="global-css_horizontal-form-layout-label-top">
    <MultiSearchDropDown
        placeholder="Title"
        :maxLength="50"
        :width="60"
        label="Title"
        :label-top="true"
        :labelWidth="20"
        :allowCustomValue="false"
        :disableFilter="true"
        :selectPrimitiveValue="true"
        :disable="modelValue.newContactSaved"
        v-model="props.modelValue.title"
        :data-source="store.state.contactTitleSelection">
    </MultiSearchDropDown>
    <TextInput
        v-model="modelValue.firstName"
        :disable="modelValue.newContactSaved"
        :maxLength="50"
        :label-top="true"
        :width="280"
        v-model:validation-fail="validationViewModel[props.validationModel].firstName"
        :requiredField="useGetValidatedFields(requiredFieldsList, 'firstName' )"
        label="First Name">
    </TextInput>
    <TextInput
        v-model="modelValue.lastName"
        :disable="modelValue.newContactSaved"
        :maxLength="50"
        :label-top="true"
        :width="280"
        v-model:validation-fail="validationViewModel[props.validationModel].lastName"
        :requiredField="useGetValidatedFields(requiredFieldsList, 'lastName' )"
        label="Last Name">
    </TextInput>
    <TextInput
        v-model="modelValue.phone"
        :disable="modelValue.newContactSaved"
        v-model:validation-fail="validationViewModel[props.validationModel].phone"
        :requiredField="useGetValidatedFields(requiredFieldsList, 'phone' )"
        :maxLength="50"
        :label-top="true"
        :width="280"
        label="Phone">
    </TextInput>
    <TextInput
        v-model="modelValue.email"
        :disable="modelValue.newContactSaved"
        v-model:validation-fail="validationViewModel[props.validationModel].email"
        :requiredField="useGetValidatedFields(requiredFieldsList, 'email' )"
        :validationText="['Required', 'Invalid Email']"
        :maxLength="50"
        :label-top="true"
        :width="280"
        label="Email">
    </TextInput>
    <div class="cmp-contact-entry_contact-link"><span @click="useContact">Use this contact</span>
      <i title="Use the contact only for this job. It will not be saved" class="fa fa-info-circle icon-info"/>
    </div>
  </div>

</template>

<style scoped lang="scss">
.cmp-contact-entry {

  &_contact-link {
    font-size: 12px;
    color: #0fa4c7;
  }

  &_contact-link:hover {
    text-decoration: underline;
  }
}
</style>
